import styled from 'styled-components'
import { Label } from 'semantic-ui-react'

export const SelectorTrigger = styled.span`
  color: var(--market-selector-color);
  cursor: pointer;
  max-height: 17px;

  > strong {
    display: inline-block;
    margin-left: 0.3rem;
    color: var(--all-markets-text-color);
  }
`

export const MarketSelectorWrap = styled.div`
  &#market-selector {
    display: flex;
    justify-content: end;
    align-items: center;
    min-width: 270px;

    input {
      caret-color: transparent;
      color: transparent;
    }

    .menu {
      min-width: 270px;
    }

    .selected {
      background-color: rgba(var(--primary-rgb), 0.15);
    }
  }

  &.market-selector .visible > .disabled.item:hover {
    background: var(--white);
  }

  &.ui.dropdown.market-selector .menu .selected.item {
    background: var(--medium-grey);
  }

  &#market-selector div.visible.menu.transition {
    max-height: 80vh;
    height: 650px;
    margin-top: 10px;
  }

  &.custom-dropdown .menu {
    overflow-y: auto;
  }

  &.custom-dropdown .menu > .item:nth-last-child(2) {
    position: sticky;
    bottom: 50px;
    z-index: 99;
    background-color: white !important;
  }

  &.custom-dropdown .menu > .item:last-child {
    position: sticky;
    bottom: 0;
    z-index: 100;
    background-color: white;
    border-top: 1px solid rgba(34, 36, 38, 0.1);
  }

  &.custom-dropdown .ui.button.green {
    opacity: 1 !important;
  }

  &.custom-dropdown .ui.button.green:disabled {
    opacity: 0.6 !important;
  }
`

export const MarketHeader = styled.div`
  background: var(--marketplace-header-bg);
  padding: 6px;
  margin: -5px -15px;
  font-size: 11px;
  display: flex;
  justify-content: space-between;
`

export const MarketCity = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CountLabel = styled(Label)`
  padding: 4px 8px !important;
`
